module.exports = __webpack_public_path__ + "static/media/Screenshot2.5bbbc5b3.png";